module.exports = __webpack_public_path__ + "media/form-type-page/thumbs-up-b912a281.svg";